import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { DeleteAssessmentCredentialModule } from 'src/app/pages/mission-control-page/assessments-management/delete-assessment-credential/delete-assessment-credential.module';
import { CompanyPageDeleteAssessmentCredentialModalComponent } from './company-page-delete-assessment-credential-modal.component';

@NgModule({
  declarations: [CompanyPageDeleteAssessmentCredentialModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    DeleteAssessmentCredentialModule
  ],
  exports: [CompanyPageDeleteAssessmentCredentialModalComponent],
  entryComponents: [CompanyPageDeleteAssessmentCredentialModalComponent]
})
export class CompanyPageDeleteAssessmentCredentialModalModule { }
